// extracted by css-extract-rspack-plugin
export default {"promo":"MHBRj","texts":"NFIc1","text":"ZEHF2"};